import React from "react";
import { render } from "react-dom";
import SignupContainer from "./components/signup/signupContainer";
import PublicWrapper from "./layouts/PublicWrapper";

require("../less/app.less");
//get the current url params
let params = new URLSearchParams(document.location.search);
const domain = params.get("domain");
render(
    <PublicWrapper>
        <SignupContainer domain={domain} />
    </PublicWrapper>,
    document.getElementById("signupForm")
);
